/***************************************************************************************************
 * POLYFILLS PER SUPPORTARE BROWSER VECCHI (iOS, Safari, ecc.)
 **************************************************************************************************/

import 'zone.js'; // Necessario per Angular

import 'core-js/es/promise';
import 'core-js/es/array';
import 'core-js/es/object';
import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/reflect';
import 'core-js/proposals/reflect-metadata';

// Solo se usi Angular animations
import 'web-animations-js';
